import React from "react";
import { Avatar } from "antd";
import { AvatarComponentProps } from "../types";

/**
 * AvatarComponent
 *
 * Displays an employee's avatar image or a fallback initial-based avatar.
 *
 * Features:
 * - Shows the employee's profile image when available
 * - Falls back to a styled initial (first letter of first name) when no image is available
 * - Uses consistent styling for the fallback avatar
 *
 * @param {AvatarComponentProps} props - Component properties
 * @param {Object} props.record - Record containing employee data
 * @param {Object} props.record.employee - Employee information
 * @param {string} [props.record.employee.avatar_url] - URL to the employee's avatar image
 * @param {string} [props.record.employee.first_name] - Employee's first name
 *
 * @returns {JSX.Element} Avatar component displaying image or initial
 */
const AvatarComponent: React.FC<AvatarComponentProps> = ({ record }) => {
  // Extract first letter from employee's first name, if available
  const initial = record?.employee?.first_name?.charAt(0) || "";

  // Default avatar styles
  const defaultStyle: React.CSSProperties = {
    color: "#f56a00",
    backgroundColor: "#fde3cf",
  };

  return record?.employee?.avatar_url ? (
    <Avatar src={record.employee.avatar_url} />
  ) : (
    <Avatar style={defaultStyle}>{initial}</Avatar>
  );
};

export default AvatarComponent;
